import ChallengesListing from './ChallengesListing';

export default ChallengesListing;
